import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_INDENTS_LIST = createRequestTypes('GET_INDENTS_LIST');
export const GET_EMAILS_LIST = createRequestTypes('GET_EMAILS_LIST');
export const GET_DISTRICT_LIST = createRequestTypes('GET_DISTRICT_LIST');
export const SAVE_FILTERS = createRequestTypes('SAVE_FILTERS');
export const RESET_TABLE = createRequestTypes('RESET_TABLE');
export const UPDATE_TAB = createRequestTypes('UPDATE_TAB');
export const ASSIGN_INDENT = createRequestTypes('ASSIGN_INDENT');
export const UNTICK_FLAGS = createRequestTypes('UNTICK_FLAGS');
export const RESET_INDENT_COUNT = createRequestTypes('RESET_INDENT_COUNT');
export const GET_HEADER_DETAILS = createRequestTypes('GET_HEADER_DETAILS');
export const VIEW_FREIGHT = createRequestTypes('placement/VIEW_FREIGHT');
export const CLEAR_VIEW_FILE = createRequestTypes('placement/CLEAR_VIEW_FILE');
export const GET_CONSIGNER_CODES = createRequestTypes('GET_CONSIGNER_CODES');
export const FETCH_EXPIRE_REASON = createRequestTypes('placement/details/FETCH_EXPIRE_REASON');
export const EXPIRE_INDENT = createRequestTypes('placement/details/EXPIRE_INDENT');
export const SET_DEMAND_STATE_CONTEXT = 'placement/SET_DEMAND_STATE_CONTEXT';
export const RESET_EXPIRE_INDENT = 'placement/RESET_EXPIRE_INDENT';
export const SET_SELECTED_ORIGIN_FILTERS = 'placement/SET_SELECTED_ORIGIN_FILTERS';
export const SET_SELECTED_DESTN_FILTERS = 'placement/SET_SELECTED_DESTN_FILTERS';
export const getIndentsList = {
  request: (params) => createAction(GET_INDENTS_LIST[REQUEST], { params }),
  success: (response, params) => createAction(GET_INDENTS_LIST[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_INDENTS_LIST[FAILURE], { response }),
  resetTable: () => createAction(RESET_TABLE),
  saveFilters: (filter) => createAction(SAVE_FILTERS, { filter }),
  updateTab: (value) => createAction(UPDATE_TAB, { value }),
  untickFlags: () => createAction(UNTICK_FLAGS),
};

export const getConsignerCodes = {
  request: (payload) => createAction(GET_CONSIGNER_CODES[REQUEST], { payload }),
  success: (response) => createAction(GET_CONSIGNER_CODES[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_CODES[FAILURE], { response }),
};

export const getEmailsList = {
  request: (params) => createAction(GET_EMAILS_LIST[REQUEST], { params }),
  success: (response, params) => createAction(GET_EMAILS_LIST[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_EMAILS_LIST[FAILURE], { response }),
};
export const getDistrictList = {
  request: (params) => createAction(GET_DISTRICT_LIST[REQUEST], { params }),
  success: (response, params) => createAction(GET_DISTRICT_LIST[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_DISTRICT_LIST[FAILURE], { response }),
};

export const assignIndent = {
  request: (payload) => createAction(ASSIGN_INDENT[REQUEST], { payload }),
  success: (response, payload) => createAction(ASSIGN_INDENT[SUCCESS], { response, payload }),
  failure: (response) => createAction(ASSIGN_INDENT[FAILURE], { response }),
};

export const getHeaderDetails = {
  request: (params) => createAction(GET_HEADER_DETAILS[REQUEST], { params }),
  success: (response, params) => createAction(GET_HEADER_DETAILS[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_HEADER_DETAILS[FAILURE], { response }),
};

export const viewFreight = {
  request: (params) => createAction(VIEW_FREIGHT[REQUEST], { params }),
  success: (response) => createAction(VIEW_FREIGHT[SUCCESS], { response }),
  failure: (response) => createAction(VIEW_FREIGHT[FAILURE], { response }),
  clearViewFile: () => createAction(CLEAR_VIEW_FILE),
};

export const fetchExpireReason = {
  request: (payload) => createAction(FETCH_EXPIRE_REASON[REQUEST], { payload }),
  success: (response, payload) => createAction(FETCH_EXPIRE_REASON[SUCCESS], { response, payload }),
  failure: (response) => createAction(FETCH_EXPIRE_REASON[FAILURE], { response }),
};

export const expireIndent = {
  request: (params) => createAction(EXPIRE_INDENT[REQUEST], { params }),
  success: (response) => createAction(EXPIRE_INDENT[SUCCESS], { response }),
  failure: (response) => createAction(EXPIRE_INDENT[FAILURE], { response }),
};

export const setExpireDemand = () => ({
  type: RESET_EXPIRE_INDENT,
});

export const setSelectedOriginFilters = (payload) => ({
  type: SET_SELECTED_ORIGIN_FILTERS,
  payload,
});
export const setSelectedDestinationFilters = (payload) => ({
  type: SET_SELECTED_DESTN_FILTERS,
  payload,
});
